import { render, staticRenderFns } from "./SoundTagSearchEditor.vue?vue&type=template&id=598cb58d&scoped=true"
import script from "./SoundTagSearchEditor.vue?vue&type=script&lang=js"
export * from "./SoundTagSearchEditor.vue?vue&type=script&lang=js"
import style0 from "./SoundTagSearchEditor.vue?vue&type=style&index=0&id=598cb58d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598cb58d",
  null
  
)

export default component.exports